import React, { useState } from 'react';
import { Link } from 'react-scroll';
import ButtonContact from "../ButtonContact/ButtonContact";
import { TfiClose } from "react-icons/tfi";
import "./Navbar.scss";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className="navbar-container">
      <div className="navbar-container__content">
        <div>
          <img
            className="navbar-container__logo"
            src="https://64.media.tumblr.com/bd0a39f2383821f8c6d7ec820e5d652e/f1783721eafc80a9-79/s540x810/b970dacaa88a98962d3d3808615a830ebf81ef09.pnj"
            alt="Logo da LimpEletro"
          />
        </div>
        
        <div className={`navbar-container__products-contact ${isMenuOpen ? 'open' : ''}`}>
          <button className="close-menu-button" onClick={closeMenu}> <TfiClose size={20}/> </button>
          <Link
            to="Products"
            className="menu-item"
          >
            Quem somos
          </Link>
          <Link
            to="Section"
            className="menu-item"
          >
            Segmentos
          </Link>
          <Link
            to="SliderProducts"
            className="menu-item"
          >
            Nossos Produtos
          </Link>
          <ButtonContact />
        </div>

        <div className="navbar-container__hamburger" onClick={toggleMenu}>
          <div className="navbar-container__hamburger-bar"></div>
          <div className="navbar-container__hamburger-bar"></div>
          <div className="navbar-container__hamburger-bar"></div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
